/**
 * Voz real de coaches de softball (VOC de la ficha DPS-33), citada con su
 * fuente. NO son reseñas del producto: el producto es nuevo y no tiene
 * compradores todavía. Cuando haya reseñas reales de compradores, se pueden
 * sumar como una sección aparte.
 */
export type Voice = {
  quote: string
  source: string
  /** Dónde lo resuelve el pack. */
  answer?: string
}

export const painVoices: Voice[] = [
  {
    quote:
      'Trying to set up a practice plan for each practice/week spreadsheet to keep us all organized',
    source: 'First-year 11U travel coach · discussfastpitch.com',
    answer:
      'The plans are already written — plus a week-by-week season calendar to drop them into.',
  },
  {
    quote:
      'remember that you get a very limited amount of time with them so run efficient practices',
    source: 'Advice to a new coach · r/Softball',
    answer:
      'The First-15 Routine and station rotations, so no minute of field time is wasted.',
  },
  {
    quote:
      'the parents are often harder to manage than a bunch of little girls',
    source: 'Veteran coach · r/Softball',
    answer:
      'A parent-meeting script, a playing-time plan and scripts for the tough conversations.',
  },
]

export const wantVoices: Voice[] = [
  {
    quote:
      'Always walk in with a plan - plan out every practice before the practice',
    source: 'Coach advice thread · r/Softball',
    answer: '43 practices already planned on the 4-Block Practice System.',
  },
  {
    quote:
      'I’m aspiring to include games in every practice to heighten the engagement and joy',
    source: '6U coach · discussfastpitch.com',
    answer:
      'Block 4 — Compete & Close — ends every single practice with a game.',
  },
  {
    quote:
      'A drill or game that is fantastic at one age or with one group will flop with another',
    source: 'Youth coach · discussfastpitch.com',
    answer:
      'Every practice in three levels: 6U–8U, 10U–12U and HS & rec — with how to make it easier or harder.',
  },
]
